/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Fallback_Model_Used_TitleInputs */



/**
* | output |
* | --- |
* | "Fallback model used" |
*
* @param {Chat_Fallback_Model_Used_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_fallback_model_used_title = /** @type {((inputs?: Chat_Fallback_Model_Used_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Fallback_Model_Used_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fallback-Modell verwendet")
	return /** @type {LocalizedString} */ ("Fallback model used")
});